import axiosInstance from '@/store/axios'
import { rejectErrorApi } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    timezones ({ commit }, data) {
      const params = {}
      if (data && data.ids) {
        params['id[in]'] = data.ids
      }
      return axiosInstance.get('/api/v1/timezones', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    layouts ({ commit }, params) {
      return axiosInstance.get('/api/v1/layouts', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    templates ({ commit }, data) {
      const params = {}
      if (data && data.ids) {
        params['id[in]'] = data.ids
      }
      return axiosInstance.get('/api/v1/templates', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    tags ({ commit }, params) {
/*      const params = {};
      if (data && data.ids) {
        params['id[in]'] = data.ids;
      }
      if (data && data.auto !== undefined) {
        params['auto[eq]'] = data.auto === true ? 1 : 0;
      } */
      return axiosInstance.get('/api/v1/tags', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    genres ({ commit }, params) {
      return axiosInstance.get('/api/v1/genres', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    categories ({ commit }, params) {
      return axiosInstance.get('/api/v1/categories', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
  },
}
